import ExceptionLogger from "./ExceptionHelper";

function testTwilioTlsConnection(smid) {
    const smidDisplay = smid != null ? `SMID: ${smid}` : "SMID: N/A";
    
    fetch("https://tls-test.twilio.com/", { method: "GET" })
        .then((response) => {
            if (!response || response.status !== 200) {
                const error = new Error(`Twilio TLS test failed: Status ${response?.status || "N/A"}, ${smidDisplay}, User Agent: ${navigator?.userAgent ?? "unknown"}`);
                ExceptionLogger(error, "testTwilioTlsConnection", "Twilio TLS connectivity test failed", "", { status: response?.status, smid: smid, userAgent: navigator?.userAgent });
                return;
            }

            ExceptionLogger(null, "testTwilioTlsConnection", `Twilio TLS test call succeeded with status code 200, ${smidDisplay}`, "", { status: response.status, smid: smid, userAgent: navigator?.userAgent }, true);
        })
        .catch((error) => {
            let errorMessage = "Unknown error";
            if (error instanceof Error) {
                errorMessage = error.message;
            } else if (error) {
                errorMessage = String(error);
            }
            const err = new Error(`Twilio TLS test failed: ${errorMessage}, ${smidDisplay}, User Agent: ${navigator?.userAgent ?? "unknown"}`);
            ExceptionLogger(err, "testTwilioTlsConnection", "Twilio TLS connectivity test error", "", { errorMessage, smid: smid, userAgent: navigator?.userAgent });
        });
}

export default testTwilioTlsConnection;
